import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import {
  SearchResultBoxComponent,
  SearchResultsBoxComponent,
  SearchSearchAutocompleteComponent,
  SearchTitleComponent,
} from './components';
import { SearchRoutingModule } from './search-routing.module';
import { SearchView } from './search/search.view';

@NgModule({
  declarations: [
    SearchView,
    SearchSearchAutocompleteComponent,
    SearchTitleComponent,
    SearchResultBoxComponent,
    SearchResultsBoxComponent,
  ],
  imports: [CommonModule, SharedModule, SearchRoutingModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
  exports: [SearchSearchAutocompleteComponent],
})
export class SearchModule {}
